import { FunctionComponent, useCallback, useState } from 'react';
import { useExport } from '../hooks/useExport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { CircularProgress } from '@material-ui/core';

type Props = {
  filters: Record<string, any>;
  color?: string;
  hoverColor?: string;
  hoverShadow?: string;
  transitionDuration?: string;
  size?: string;
};

const DownloadTravelsXlsx: FunctionComponent<Props> = ({
  filters,
  color = '#9CD0FF',
  hoverColor = '#9CD0FF',
  hoverShadow = 'drop-shadow(0 0 3px rgba(76, 175, 80, 0.6))',
  transitionDuration = '0.3s',
  size = '18px',
}) => {
  const { getExportData, isLoading } = useExport();
  const [isHovered, setIsHovered] = useState(false);

  const onDownloadFile = useCallback(async () => {
    const response = await getExportData(filters);
    const arrayBuffer = Buffer.from(response.data);
    const blob = new Blob([arrayBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'listado-reservas.xlsx');
    document.body.appendChild(link);
    link.click();
  }, [filters, getExportData]);

  const isActive = isLoading || isHovered;

  return (
    <div
      title="Imprimir"
      onClick={() => {
        if (isLoading) return;
        onDownloadFile();
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        cursor: isLoading ? 'not-allowed' : 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '8px 12px',
        userSelect: 'none',
        opacity: isLoading ? 0.6 : 1,
        transition: `all ${transitionDuration} ease`
      }}
    >
      <FontAwesomeIcon
        icon={faPrint}
        style={{
          color: isActive ? hoverColor : color,
          fontSize: size,
          transition: `all ${transitionDuration} ease`,
          filter: isActive ? hoverShadow : 'none',
          transform: isActive && !isLoading ? 'scale(1.1)' : 'scale(1)'
        }}
      />
      <span
        style={{
          color: isActive ? hoverColor : color,
          fontSize: '14px',
          fontWeight: 500,
          transition: `all ${transitionDuration} ease`,
          whiteSpace: 'nowrap'
        }}
      >
        {isLoading && (
          <span
            style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}
          >
            <CircularProgress size={12} style={{ color: color }} />
            Descargando...
          </span>
        )}
      </span>
    </div>
  );
};

export default DownloadTravelsXlsx;
